import { courseDetailUrl } from "../../API/urls";
import { CourseItem } from "../../API";

export function getMeetingHrefProps(course: CourseItem) {
    let params = {
        href: "",
        target: ""
    };
    if (course.meetingArray?.length > 0) {
        params.href = courseDetailUrl(
            course?.courseNo,
            course?.courseSeq,
            course?.weekTimeId,
            "meeting"
        );
    } else {
        params.href = course.meetingUrl;
        params.target = "_blank";
    }
    return params;
}
